import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { selectSelectedTableRowsCount } from 'services/selectedTableCells/selectors';

interface Props {
    count?: number;
}

export class SelectedTableRowsCount extends React.Component<Props> {
    render() {
        const { count } = this.props;
        if (!count) {
            return null;
        }

        return count;
    }
}

const mapStateToProps = createStructuredSelector({
    count: selectSelectedTableRowsCount
});

export default connect(mapStateToProps)(SelectedTableRowsCount);
